import { create } from "zustand";
import ApiHelper from "src/services/ApiHelper.service";

type ACLStore = {
  user: User[];
  role: Role[];
  policy: Policy[];
  permission: Permission[];
  getACL: (type: string) => Promise<void>;
  deleteACL: (type: string, id: string) => Promise<boolean>;
};

const initialState = {
  user: [],
  role: [],
  policy: [],
  permission: [],
};

export const useACLStore = create<ACLStore>()((set, get) => ({
  ...initialState,
  getACL: async (type: string) => {
    ApiHelper.get(type === "user" ? `/${type}` : `/acl/${type}`)
      .then((res) => set({ [type]: res }))
      .catch((err) => {
        if (err.statusCode !== 401) {
          alert("Something went wrong! \n" + JSON.stringify(err));
        }
      });
  },
  deleteACL: async (type: string, id: string) => {
    const boo = window.confirm(`Confirm to delete this ${type}?`);
    if (boo) {
      ApiHelper.delete(`/acl/${type}/${id}`)
        .then(() => {
          const item = get() as any;
          item[type].splice(
            item[type].findIndex((m: any) => m.id === id),
            1
          );
          set({ [type]: item[type] });
        })
        .catch((err) => {
          if (err.statusCode !== 401) {
            alert("Something went wrong! \n" + JSON.stringify(err));
          }
        });
    }

    return boo;
  },
}));

export type User = {
  email: string;
  groups: string | null;
  id: string;
  name: string;
  photo: string;
  roles: Role[];
};

export type Role = {
  description: string;
  id: string;
  name: string;
  policies: Policy[];
};

export type Policy = {
  description: string;
  id: string;
  name: string;
  permissions: Permission[];
};

export type Permission = {
  description: string;
  id: string;
  name: string;
  permission: string;
};
